var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "position-index-11",
          attrs: { app: "", fixed: "", "mini-variant": _vm.mini },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c(
            "v-list",
            { staticClass: "pa-0" },
            [
              _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      attrs: {
                        slot: "activator",
                        avatar: "",
                        tag: "div",
                        href: "https://www.targetfirst.com/",
                        target: "_blank"
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-img", {
                            attrs: { src: "../../static/notif_icone.png" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Target First")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("wz-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "sessionTimer" }, [
            _vm._v(_vm._s(_vm.remainingFormatted))
          ]),
          _vm._v(" "),
          true
            ? _c(
                "v-footer",
                { attrs: { absolute: "", color: "transparent" } },
                [
                  _c(
                    "v-chip",
                    { attrs: { label: "", disabled: "", small: "" } },
                    [_vm._v("v" + _vm._s(_vm.myVersion))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "position-index-11",
          attrs: {
            "disable-route-watcher": "",
            app: "",
            fixed: "",
            right: "",
            temporary: "",
            width: "350",
            "hide-overlay": ""
          },
          model: {
            value: _vm.helper,
            callback: function($$v) {
              _vm.helper = $$v
            },
            expression: "helper"
          }
        },
        [
          _c("wz-help", {
            attrs: { opened: _vm.helper },
            on: {
              "update:opened": function($event) {
                _vm.helper = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "position-index-11",
              attrs: {
                "disable-route-watcher": "",
                "disable-resize-watcher": "",
                app: "",
                fixed: "",
                right: "",
                "hide-overlay": "",
                width: "350"
              },
              model: {
                value: _vm.showSatisfactionAgent,
                callback: function($$v) {
                  _vm.showSatisfactionAgent = $$v
                },
                expression: "showSatisfactionAgent"
              }
            },
            [
              _c("wz-satisfaction-agent", {
                attrs: { opened: _vm.showSatisfactionAgent },
                on: {
                  "update:opened": function($event) {
                    _vm.showSatisfactionAgent = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          staticClass: "position-index-10",
          attrs: { app: "", dense: "", id: "toolBarApp" }
        },
        [
          _c("v-toolbar-side-icon", {
            attrs: { dark: "" },
            nativeOn: {
              click: function($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              }
            }
          }),
          _vm._v(" "),
          _c("v-toolbar-title", { staticClass: "white--text" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          !_vm.isMobile ? _c("wz-pupitre-status") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "template",
                { slot: "activator" },
                [_c("wz-notifications")],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("dashNotif")))])
            ],
            2
          ),
          _vm._v(" "),
          _c("wz-agent-status"),
          _vm._v(" "),
          _c("wz-agent-menu"),
          _vm._v(" "),
          _vm.$store.state._Toolbar.tabs.length || (_vm.back && _vm.subTitle)
            ? _c(
                "v-tabs",
                {
                  staticClass: "tfSousMenu",
                  attrs: { slot: "extension", "show-arrows": "" },
                  slot: "extension"
                },
                [
                  _c("v-tabs-slider", {
                    staticStyle: { height: "4px" },
                    attrs: { color: "accent" }
                  }),
                  _vm._v(" "),
                  _vm.back && _vm.subTitle
                    ? _c(
                        "v-toolbar-side-icon",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ path: _vm.back })
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_back")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.back && _vm.subTitle
                    ? _c("v-subheader", { staticClass: "subheading" }, [
                        _vm._v(_vm._s(_vm.subTitle))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.$store.state._Toolbar.tabs, function(tab) {
                    return _c(
                      "v-tab",
                      {
                        key: tab.title,
                        staticClass: "mr-3",
                        attrs: { to: tab.to, exact: "" }
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$tc(tab.title, 2, { count: "" })) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        tab.to == "/trafic/chatting"
                          ? _c(
                              "v-badge",
                              {
                                staticClass: "badgeTopMenu",
                                attrs: {
                                  right: "",
                                  color: "accent",
                                  value:
                                    tab.to == "/trafic/chatting" &&
                                    _vm.$store.state._StoreWatcheeBox
                                      .sessionsPrivees.length
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "caption",
                                    attrs: { slot: "badge" },
                                    slot: "badge"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$store.state._StoreWatcheeBox
                                          .sessionsPrivees.length
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : tab.to == "/trafic/attente"
                          ? _c(
                              "v-badge",
                              {
                                staticClass: "badgeTopMenu",
                                attrs: {
                                  right: "",
                                  color: "accent",
                                  value:
                                    tab.to == "/trafic/attente" &&
                                    _vm.getMessageAttente
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "caption",
                                    attrs: { slot: "badge" },
                                    slot: "badge"
                                  },
                                  [_vm._v(_vm._s(_vm.getMessageAttente))]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize",
              value: _vm.viewSizeScreen,
              expression: "viewSizeScreen"
            }
          ],
          class: {
            contentVuePages: !_vm.isMobile,
            "contentVuePages-mobile": _vm.isMobile
          }
        },
        [
          !_vm.licenceURL
            ? _c(
                "v-alert",
                {
                  style:
                    _vm.$vuetify.breakpoint.mdOnly ||
                    _vm.$vuetify.breakpoint.smOnly ||
                    _vm.$vuetify.breakpoint.xsOnly
                      ? "width: 100%;"
                      : "width: calc(100% - 80px);",
                  attrs: {
                    value: true,
                    type: "error",
                    id: "alertLicenceInactive"
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.$t("activeLicence1")) + " "),
                  _c("a", { attrs: { href: "#/management/sites" } }, [
                    _vm._v("-> " + _vm._s(_vm.$t("activeLicenceURL")))
                  ]),
                  _vm._v(".\n        "),
                  _c("br"),
                  _vm._v("\n        " + _vm._s(_vm.$t("activeLicence2")) + " "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://support.targetfirst.com/?s=installation",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("activeLicenceFAQ")))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-x-reverse-transition", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("wz-notifier"),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogVisiteurOffline,
            callback: function($$v) {
              _vm.dialogVisiteurOffline = $$v
            },
            expression: "dialogVisiteurOffline"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("visitorOffline")))]
              ),
              _vm._v(" "),
              _vm.visiteurChangePage
                ? _c("v-card-text", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("trasfertChangePage")) +
                        " \n        "
                    )
                  ])
                : _c("v-card-text", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("transfertOffline")) +
                        "\n        "
                    )
                  ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.visiteurChangePage
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "accent",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeDialogVisiteurChangePage()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("ok")) + "\n          ")]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "primary",
                          on: {
                            click: function($event) {
                              return _vm.closeTransfertClient()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("close")) + "\n          ")]
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("wz-dialog"),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogTransfere,
            callback: function($$v) {
              _vm.dialogTransfere = $$v
            },
            expression: "dialogTransfere"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.datasTransfere.msg))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("findNewChatInChatting")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "accent",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.rejetTransfertClient()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      on: {
                        click: function($event) {
                          return _vm.acceptTransfertClient()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogReconnexion,
            callback: function($$v) {
              _vm.dialogReconnexion = $$v
            },
            expression: "dialogReconnexion"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("connectionInterrupted")))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("noLongerConnected")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.sessionDejaActive
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "primary",
                          attrs: { disabled: !_vm.btConnexion },
                          on: {
                            click: function($event) {
                              return _vm.reconnexionBO(
                                "Connexion Internet interrompue avec multisession"
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("reconnection")))]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "primary",
                          attrs: { disabled: !_vm.btConnexion },
                          on: {
                            click: function($event) {
                              return _vm.reconnexionBO(
                                "Connexion Internet interrompue"
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("reconnection")))]
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.dialogScript,
            callback: function($$v) {
              _vm.dialogScript = $$v
            },
            expression: "dialogScript"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("dashOups")))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm.noMainSite
                  ? _c("p", [
                      _vm._v(_vm._s(_vm.$t("scriptInstallationNotOk3")) + " "),
                      _c("br"),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://admin.targetfirst.com/#/management/sites"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("scriptInstallationNotOk4")) +
                              " "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("scriptInstallationNotOk")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("scriptInstallationNotOk2")) + " "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://support.targetfirst.com/?s=installation",
                        target: "_blank"
                      }
                    },
                    [_vm._v(" article")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary--text",
                      attrs: { block: "", flat: "", loading: _vm.isChecking },
                      on: {
                        click: function($event) {
                          return _vm.checkScript()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("testAgain")) +
                          "\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("refresh")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.activeDialogMultiSession,
            callback: function($$v) {
              _vm.activeDialogMultiSession = $$v
            },
            expression: "activeDialogMultiSession"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("titleDialogMultiSession")))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.checkPHPsessionID
                        ? _vm.$t("contentDialogMultiSessionPhp")
                        : _vm.$t("contentDialogMultiSession")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              !_vm.checkPHPsessionID
                ? _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("no")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.reconnexionAgent()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("yes")) + "\n          ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.debloqueMultiSession()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("unblock")) +
                              " ( " +
                              _vm._s(_vm.formattedTime) +
                              " )\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.usrBoNotif === "1"
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "480" },
              model: {
                value: _vm.activeDialogPagesVues,
                callback: function($$v) {
                  _vm.activeDialogPagesVues = $$v
                },
                expression: "activeDialogPagesVues"
              }
            },
            [
              _c(
                "v-card",
                [
                  _vm.LicenceOUT
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warning")) +
                              " " +
                              _vm._s(_vm.$t("warningLicence")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.fullQuotaPagesVues
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warningTracked")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.fullQuotaChats
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warningTrackedChat")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.expireLicence
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warning")) +
                              " " +
                              _vm._s(_vm.$t("warningExpired")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.sursisLicence
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warningExpired")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.$store.state._User.entBusiness == "pv"
                    ? _c(
                        "v-card-title",
                        { staticClass: "orange white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("infoConsumption") +
                                  _vm.quotaPages.toFixed(2) +
                                  " %"
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.$store.state._User.entBusiness == "chat"
                    ? _c(
                        "v-card-title",
                        { staticClass: "orange white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("infoConsumptionChat") +
                                  _vm.quotaChats.toFixed(2) +
                                  " %"
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.LicenceOUT
                    ? _c("v-card-text", [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("txt1WarningLicence")))
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("txt2WarningLicence") + _vm.supportEmail
                            )
                          )
                        ])
                      ])
                    : _vm.fullQuotaPagesVues
                    ? _c("v-card-text", [
                        _c("h3", [_vm._v(_vm._s(_vm.$t("txt1AlertQuota")))]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt2AlertQuota")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt3AlertQuota")))]),
                        _vm._v(
                          "\n          " + _vm._s(_vm.$t("txt5InfoQuota")) + " "
                        ),
                        _c("b", [
                          _vm._v(_vm._s(_vm.$store.state._User.entNbPageMax))
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n          " + _vm._s(_vm.$t("txt6InfoQuota")) + " "
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.renouvellementDay
                                ? _vm.$t("in") + " " + _vm.renouvellementDay
                                : ""
                            ) +
                              " " +
                              _vm._s(
                                _vm.$tc("daysQuota", _vm.renouvellementDay, {
                                  count: ""
                                })
                              )
                          )
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt2ExpireLicence")))]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$store.state._User.entRefFacturation
                                ? _vm.$t("referentFacturation") +
                                    " " +
                                    _vm.$store.state._User.entRefFacturation
                                      .CLI_EMAIL
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm.fullQuotaChats
                    ? _c("v-card-text", [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("txt1AlertQuotaChat")))
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt2AlertQuota")))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt3AlertQuotaChat")))]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("txt5InfoQuotaChat")) +
                            " "
                        ),
                        _c("b", [
                          _vm._v(_vm._s(_vm.$store.state._User.entNbPageMax))
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("txt6InfoQuotaChat")) +
                            " "
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.renouvellementDay
                                ? _vm.$t("in") + " " + _vm.renouvellementDay
                                : ""
                            ) +
                              " " +
                              _vm._s(
                                _vm.$tc("daysQuota", _vm.renouvellementDay, {
                                  count: ""
                                })
                              )
                          )
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt2ExpireLicence")))]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$store.state._User.entRefFacturation
                                ? _vm.$t("referentFacturation") +
                                    " " +
                                    _vm.$store.state._User.entRefFacturation
                                      .CLI_EMAIL
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm.expireLicence
                    ? _c("v-card-text", [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("txt1ExpireLicence") + " " + _vm.dateExpire
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt2ExpireLicence")))]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$store.state._User.entRefFacturation
                                ? _vm.$t("referentFacturation") +
                                    " " +
                                    _vm.$store.state._User.entRefFacturation
                                      .CLI_EMAIL
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm.sursisLicence
                    ? _c("v-card-text", [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("txt1ExpireLicence") + " " + _vm.dateExpire
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _c("i", [
                              _vm._v(_vm._s(_vm.$t("txt3ExpireLicence")))
                            ])
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("txt4ExpireLicence") +
                                  " " +
                                  _vm.$store.state._User.surcisLicience +
                                  " " +
                                  _vm.$tc(
                                    "days",
                                    _vm.$store.state._User.surcisLicience,
                                    { count: "" }
                                  ) +
                                  " " +
                                  _vm.$t("txt5ExpireLicence")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt2ExpireLicence")))]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$store.state._User.entRefFacturation
                                ? _vm.$t("referentFacturation") +
                                    " " +
                                    _vm.$store.state._User.entRefFacturation
                                      .CLI_EMAIL
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm.$store.state._User.entBusiness == "pv"
                    ? _c("v-card-text", [
                        _c("h3", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("txt1InfoQuota")) +
                              " " +
                              _vm._s(_vm.quotaPages.toFixed(2)) +
                              " % " +
                              _vm._s(_vm.$t("txt2InfoQuota")) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt3InfoQuota")))]),
                        _vm._v(" "),
                        _c("p", { staticClass: "red--text" }, [
                          _vm._v(_vm._s(_vm.$t("txt4InfoQuota")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("txt5InfoQuota")) +
                              " "
                          ),
                          _c("b", [
                            _vm._v(_vm._s(_vm.$store.state._User.entNbPageMax))
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("txt6InfoQuota")) +
                              " "
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.renouvellementDay
                                  ? _vm.$t("in") + " " + _vm.renouvellementDay
                                  : ""
                              ) +
                                " " +
                                _vm._s(
                                  _vm.$tc("daysQuota", _vm.renouvellementDay, {
                                    count: ""
                                  })
                                )
                            )
                          ])
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$store.state._User.entRefFacturation
                                ? _vm.$t("referentFacturation") +
                                    " " +
                                    _vm.$store.state._User.entRefFacturation
                                      .CLI_EMAIL
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm.$store.state._User.entBusiness == "chat"
                    ? _c("v-card-text", [
                        _c("h3", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("txt1InfoQuota")) +
                              " " +
                              _vm._s(_vm.quotaChats.toFixed(2)) +
                              " % " +
                              _vm._s(_vm.$t("txt2InfoQuotaChats")) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("txt3InfoQuotaChat")))]),
                        _vm._v(" "),
                        _c("p", { staticClass: "red--text" }, [
                          _vm._v(_vm._s(_vm.$t("txt4InfoQuotaChat")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("txt5InfoQuotaChat")) +
                              " "
                          ),
                          _c("b", [
                            _vm._v(_vm._s(_vm.$store.state._User.entNbChatMax))
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("txt6InfoQuotaChat")) +
                              " "
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.renouvellementDay
                                  ? _vm.$t("in") + " " + _vm.renouvellementDay
                                  : ""
                              ) +
                                " " +
                                _vm._s(
                                  _vm.$tc("daysQuota", _vm.renouvellementDay, {
                                    count: ""
                                  })
                                )
                            )
                          ])
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$store.state._User.entRefFacturation
                                ? _vm.$t("referentFacturation") +
                                    " " +
                                    _vm.$store.state._User.entRefFacturation
                                      .CLI_EMAIL
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      !_vm.LicenceOUT
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.souscrire()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("help")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                href: _vm.Support,
                                target: "support"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("support")) +
                                  "\n          "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.continuer()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("continue")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.usrBoNotif === "1"
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "480" },
              model: {
                value: _vm.activeDialogc2c,
                callback: function($$v) {
                  _vm.activeDialogc2c = $$v
                },
                expression: "activeDialogc2c"
              }
            },
            [
              _c(
                "v-card",
                [
                  _vm.C2CoffF || _vm.C2CoffM
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warning")) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warningC2C")) +
                              ". " +
                              _vm._s(
                                _vm.$t("infoConsumptionC2C") +
                                  (_vm.depassementF > _vm.depassementM
                                    ? _vm.depassementF
                                    : _vm.depassementM) +
                                  " %"
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.C2CnearF || _vm.C2CnearM
                    ? _c(
                        "v-card-title",
                        { staticClass: "orange white--text subheading" },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.$t("warning")) + " "
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warningC2Cnear")) +
                              ". "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("txt1InfoQuota")) + " "),
                      _c("br"),
                      _vm._v(
                        "- " +
                          _vm._s(_vm.depassementF) +
                          " % " +
                          _vm._s(_vm.$t("txt2InfoQuotaC2C")) +
                          " " +
                          _vm._s(_vm.$t("fixes")) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        "- " +
                          _vm._s(_vm.depassementM) +
                          " % " +
                          _vm._s(_vm.$t("mobiles")) +
                          " "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.C2CnearF || _vm.C2CnearM
                      ? _c("p", { staticClass: "red--text" }, [
                          _vm._v(_vm._s(_vm.$t("txt4InfoQuotaC2C")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("txt5InfoQuotaC2C")) + " "
                    ),
                    _c("br"),
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.$tc(
                            "hours",
                            _vm.$store.state._Sites.siteSelected
                              .c2c_quota_sites_f,
                            {
                              count:
                                _vm.$store.state._Sites.siteSelected
                                  .c2c_quota_sites_f
                            }
                          )
                        ) +
                          " " +
                          _vm._s(_vm.$t("tofixes")) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        _vm._s(
                          _vm.$tc(
                            "hours",
                            _vm.$store.state._Sites.siteSelected
                              .c2c_quota_sites_m,
                            {
                              count:
                                _vm.$store.state._Sites.siteSelected
                                  .c2c_quota_sites_m
                            }
                          )
                        ) +
                          " " +
                          _vm._s(_vm.$t("tomobiles"))
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _c("p", [_vm._v(_vm._s(_vm.$t("txt3InfoQuotaC2C")))])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      !_vm.LicenceOUT
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.souscrireC2C()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("help")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                href: _vm.Support,
                                target: "support"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("support")) +
                                  "\n          "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.continuerC2C()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("continue")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.usrBoNotif === "1"
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "480" },
              model: {
                value: _vm.activeDialogCB,
                callback: function($$v) {
                  _vm.activeDialogCB = $$v
                },
                expression: "activeDialogCB"
              }
            },
            [
              _c(
                "v-card",
                [
                  _vm.expireCB
                    ? _c(
                        "v-card-title",
                        { staticClass: "red white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warning")) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cbExpire1")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm.cbExpirebientot
                    ? _c(
                        "v-card-title",
                        { staticClass: "orange white--text subheading" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("warning")) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cbExpire5")) +
                              " " +
                              _vm._s(_vm.delaiExpireCB) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("h3", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("cbExpire2")) +
                          " " +
                          _vm._s(_vm.dateExpireLicence) +
                          ", " +
                          _vm._s(_vm.$t("cbExpire3")) +
                          " "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("cbExpire4")))])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.majCB()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("majCb")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.continuerExpireCB()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("continue")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogConnexionInactive,
            callback: function($$v) {
              _vm.dialogConnexionInactive = $$v
            },
            expression: "dialogConnexionInactive"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("sessionInactiv")))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.$t("sessionInactivPopUp")) }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue--text darken-1",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.reactiveBO()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("yes")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "450" },
          model: {
            value: _vm.dialogBugScreenshot,
            callback: function($$v) {
              _vm.dialogBugScreenshot = $$v
            },
            expression: "dialogBugScreenshot"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("sendFeedback")))]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-textarea", {
                    attrs: {
                      label: _vm.$t("yourFeedback"),
                      required: "",
                      box: ""
                    },
                    model: {
                      value: _vm.messageBug,
                      callback: function($$v) {
                        _vm.messageBug = $$v
                      },
                      expression: "messageBug"
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: _vm.imageUrl, width: "100%", height: "auto" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      attrs: {
                        loading: _vm.sendingReport,
                        disabled: !_vm.messageBug.trim().length
                      },
                      on: {
                        click: function($event) {
                          return _vm.envoiBug()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("send")) +
                          "\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [_vm._v("send")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290", persistent: "" },
          model: {
            value: _vm.dialogTooMuchAgents,
            callback: function($$v) {
              _vm.dialogTooMuchAgents = $$v
            },
            expression: "dialogTooMuchAgents"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("dashOups")))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$tc("tooMuchAgentsConnected", 1, {
                        count: _vm.$store.state._User.entNbAgent
                      })
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary--text",
                      attrs: { block: "", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("logout") + " (" + _vm.countdown + " sec.)"
                          ) +
                          "\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("exit_to_app")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.dialogClearCache,
            callback: function($$v) {
              _vm.dialogClearCache = $$v
            },
            expression: "dialogClearCache"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [
                  _vm._v(
                    _vm._s(_vm.$t("cachetitle")) + " : " + _vm._s(_vm.versionBo)
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("cachecontent1")) + "\n          "),
                _c("br"),
                _vm._v(_vm._s(_vm.$t("cachecontent2")) + " "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://support.google.com/accounts/answer/32050?hl=fr&co=GENIE.Platform%3DDesktop",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cachecontent3")))]
                ),
                _vm._v(_vm._s(_vm.$t("cachecontent4")) + "\n          "),
                _c("br"),
                _vm._v(_vm._s(_vm.$t("cachecontent5")) + "\n        ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary--text",
                      attrs: { block: "", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.reloadCache()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.$t("reloadPage")) +
                          "\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("exit_to_app")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.showCaptcha,
            callback: function($$v) {
              _vm.showCaptcha = $$v
            },
            expression: "showCaptcha"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [
                  _vm._v(
                    "Avant de commencer, merci de bien vouloir valider ce Captcha"
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("div", {
                  staticClass: "g-recaptcha",
                  attrs: {
                    "data-sitekey": "6Lce06oiAAAAACoywsL9qjXF00_epPRvpDM-_1Rw"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary--text",
                      attrs: { block: "", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.checkCaptcha()
                        }
                      }
                    },
                    [
                      _vm._v("\n\t\t\tVérifier\n            "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("exit_to_app")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "850", persistent: "" },
          model: {
            value: _vm.installProgress,
            callback: function($$v) {
              _vm.installProgress = $$v
            },
            expression: "installProgress"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("visitGuidee")))]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("dash1")) + "\n          "
                  ),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("dash2")) + "\n          "),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    _vm._s(_vm.$t("dash3")) +
                      _vm._s(_vm.progress) +
                      "%.\n          "
                  ),
                  _vm.progress < 100
                    ? _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("dash4")) +
                            "\n          "
                        )
                      ])
                    : _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("dash7")) +
                            "\n            "
                        ),
                        _c("br"),
                        _vm._v(_vm._s(_vm.$t("dash5")) + "\n          ")
                      ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("dash5")) + "\n          "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs6: "", md4: "" } }, [
                            _c("img", {
                              staticClass: "iconesAideTF",
                              attrs: {
                                src: "src/assets/img/tutos/icone_boussole.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("visitGuidee")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md4: "" } }, [
                            _c("img", {
                              staticClass: "iconesAideTF",
                              attrs: {
                                src: "src/assets/img/tutos/icone_chatbot.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("dashChatbot")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md4: "" } }, [
                            _c("img", {
                              staticClass: "iconesAideTF",
                              attrs: {
                                src: "src/assets/img/tutos/icone_bug.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", [_vm._v(_vm._s(_vm.$t("dashCenter")))])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md4: "" } }, [
                            _c("img", {
                              staticClass: "iconesAideTF",
                              attrs: {
                                src: "src/assets/img/tutos/icone_aide.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", [_vm._v(_vm._s(_vm.$t("dashAide")))])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs6: "", md4: "" } }, [
                            _c("img", {
                              staticClass: "iconesAideTF",
                              attrs: {
                                src: "src/assets/img/tutos/icone_notif.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", [_vm._v(_vm._s(_vm.$t("dashNotif")))])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { attrs: { align: "center" } },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs6: "", md3: "" } },
                        [
                          !_vm.$vuetify.breakpoint.xsOnly
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.startTuto()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("dashCommencer")) +
                                      "\n                  "
                                  ),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("send")
                                  ])
                                ],
                                1
                              )
                            : _c(
                                "v-btn",
                                {
                                  staticClass: "primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.startTuto()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("dashCommencer")) +
                                      "\n                "
                                  )
                                ]
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "", md3: "" } },
                        [
                          _vm.progress < 100
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "blue--text darken-1",
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.nextStep()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("dashVoirSection")) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "", md3: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.skipTuto()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("dashPasCetteFois")) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "", md3: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.blockTuto()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("dashDontask")) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("WzModuleWebcallAPZ")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f6782c2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6782c2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = null
// module chunks = 